import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  removeCaracteresEspeciais(texto: string) {

    if (texto != undefined && texto != null && texto != '') {
      return texto.replace(/[^\w\s]/gi, '');
    }
    return texto;
  }

  removerEspacosComecoFim(texto: string) {

    if (texto != undefined && texto != null && texto != '') {
      return texto.trim();
    }
    return texto;
  }

  cepValido(cep: string): boolean {
    // Se o valor for nulo, indefinido ou vazio, não é válido para esta lógica.
    // A validação de 'required' deve ser tratada separadamente.
    if (!cep) {
      return false;
    }

    // Remove todos os caracteres que não são dígitos (como '.' ou '-')
    const cepApenasNumeros = cep.replace(/\D/g, '');

    // Verifica se o CEP resultante tem exatamente 8 dígitos.
    if (cepApenasNumeros.length !== 8) {
      return false;
    }

    // Opcional: Verifica se todos os dígitos são iguais (ex: "00000000" ou "11111111"),
    // que são considerados inválidos, assim como no CPF.
    const cepInvalidoConhecido = /^(.)\1{7}$/;
    if (cepInvalidoConhecido.test(cepApenasNumeros)) {
      return false;
    }

    // Se passou em todas as verificações, o formato é válido.
    return true;
  }

  cpfValido(strCPF: string) {
    if (strCPF != undefined) {
      // Verificar se o CPF está no formato correto com pontos e traços
      const cpfPattern = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
      const cpfNumericPattern = /^\d{11}$/;

      if (!cpfPattern.test(strCPF) && !cpfNumericPattern.test(strCPF)) {
        return false;
      }

      // Remover caracteres especiais
      strCPF = strCPF.replace(/[^\d]/g, '');

      let Soma = 0;
      let Resto = 0;

      if (strCPF == "00000000000") return false;

      for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11)) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11)) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    } else {
      return false;
    }
  }

  formatarCNPJ(cnpj: string | number): string {
    // Converter para string se for número
    let cnpjStr = cnpj.toString();

    // Remover caracteres não numéricos
    cnpjStr = cnpjStr.replace(/[^\d]/g, '');

    // Verificar se o CNPJ tem 14 dígitos
    if (cnpjStr.length !== 14) {
      return cnpjStr;
    }

    // Formatar o CNPJ
    return cnpjStr.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }


 // Função para validar Email
 validarEmail(email: string): boolean {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(String(email).toLowerCase()) && !email.includes(',');
}

  minArrayLengthValidator(minLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control && control.value && Array.isArray(control.value)) {
        return control.value.length >= minLength ? null : { minArrayLength: true };
      }
      return { minArrayLength: true };
    };
  }


    // Função de validação de Email
    emailValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const valid = this.validarEmail(control.value);
        return valid ? null : { emailInvalid: true };
      };
    }

  olderDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Zera hora, minuto, segundo e milissegundo
      const valid = control.value < today;

      return valid ? null : { dateInvalid: true };
    };
  }

     // Função de validação de CPF
  cpfValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const valid = this.cpfValido(control.value);
      return valid ? null : { cpfInvalid: true };
    };
  }

  aboveZeroValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      //verifica se valor é menor ou igual a zero
      if(value <= 0){
        return {invalidNumber: true}
      }
      return null
    }
  }

  cepValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // Se não houver valor, o campo é considerado válido aqui.
      // A validação de campo obrigatório (required) deve ser adicionada separadamente.
      if (!control.value) {
        return null;
      }

      const valid = this.cepValido(control.value);
      // Se for válido, retorna null (sem erros). Se não, retorna um objeto de erro.
      return valid ? null : { cepInvalid: true };
    };
  }

  constructor() {

  }
}
